export enum UserSelectionQuickFilter {
  ALL_USERS = "allUsers",
  SELECTED_USERS = "selectedUsers",
  UNSELECTED_USERS = "unselectedUsers",
}
